import Vue from 'vue';
import VueScrollTo from 'vue-scrollto';
import VueYouTubeEmbed from 'vue-youtube-embed';
import VueI18n from 'vue-i18n';

import App from '@/App.vue';
import router from '@/router';
import store from '@/store';
import vuetify from '@/plugins/vuetify';
import { Ripple } from 'vuetify/lib/directives';
import '@/plugins/analytics';
import '@/plugins/tagmanager';
import '@/plugins/socialsharing';
import '@/plugins/cookies';
import messages from './lang';

Vue.config.productionTip = false;

Vue.use(VueScrollTo);
Vue.use(VueYouTubeEmbed);
Vue.use(VueI18n);
Vue.use(vuetify, {
  directives: {
    Ripple,
  },
});

const i18n = new VueI18n({
  locale: 'br', // set locale
  messages, // set locale messages
});

Vue.component('default-layout', () => import('@/layouts/Default.vue'));
Vue.component('content-layout', () => import('@/layouts/Content.vue'));
Vue.component('clean-layout', () => import('@/layouts/Clean.vue'));
Vue.component('checkout-layout', () => import('@/layouts/Checkout.vue'));
Vue.component('performance-report-layout', () =>
  import('@/layouts/PerformanceReport.vue'),
);
Vue.component('home-layout', () => import('@/layouts/Home.vue'));

new Vue({
  router,
  store,
  vuetify,
  i18n,
  render: h => h(App),
}).$mount('#app');
